module.exports = __webpack_public_path__ + "media/fountain2.4ba634dc.webm";